import { CommonHeader } from "../../components/commons";
import { connect } from "react-redux";
import { ClientDashboardCard } from "../../components/ClientDashboard";
import { RootState } from "../../redux/rootReducers";
import { useEffect } from "react";
type AppProps = {
  history?: any;
  sideMenus?: any[];
};


const MasterData = ({ history, sideMenus }: AppProps) => {
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])


  const handleRedirection = (moduleName: string | undefined) => {
    switch (moduleName) {
      case "redirectToMasterBranch":
        return history.push(`/master-data/branch`);
      case "redirectToMasterCurrency":
        return history.push("/master-data/currency");
      case "redirectToMasterActivityCode":
        return history.push("/master-data/activity-code");
      case "redirectToMasterClientGroup":
        return history.push("/master-data/client-group");
      case "redirectToMasterEmail":
        return history.push("/master-data/email");
      case "redirectToMasterHolidayCalender":
        return history.push("/master-data/holiday-calender");
      case "redirectToMasterClientCategory":
        return history.push("/master-data/client-category");
      case "redirectToMasterUsersDepartment":
        return history.push("/master-data/user-department");
      case "redirectToTdsModule":
          return history.push("/master-data/tds-and-tcs-master");
      case "redirectToSkillsAndQualification":
          return history.push("/master-data/skills-and-qualifications");
      case "redirectToScopeOfWork":
          return history.push("/master-data/scope-of-work")
      case "redirectToPdfTemplatesMaster":
        return history.push("/master-data/invoice-templates")
      default:
        return null;
    }
  };
  const renderModules = () => {
    let MasterData: any =
      sideMenus &&
      sideMenus?.length > 0 &&
      sideMenus?.filter((menu) => menu?.menu_name === "Master Data");

    let finalList = MasterData[0]?.sub_menu?.map((list: any) => {
      return (
        <div className={`col-md-4 mb-4 ${list.extraClasses}`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      );
    });

    return finalList;
  };
  return (
    <div>
      <CommonHeader title="Master Data" />
      <div className="row mt-3">{renderModules()}</div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  sideMenus: state.auth.sideMenus,
});
export default connect(mapStateToProps)(MasterData);
